export interface RiskStep {
  id?: number;
  profitMinEUR: number;
  riskPerTradeEUR: number;
}

export interface RiskProfile {
  id?: string;
  maxLossThresholdEUR: number;
  baseRiskPerTradeEUR: number;
  riskSteps: RiskStep[];
  riskRewardRatio?: number;
  winProbabilityPct?: number;
  targetGoalEUR?: number;
  planYear?: number;
}

const currentYear = new Date().getFullYear();
export const DEFAULT_RISK_STEPS: RiskStep[] = [
  { profitMinEUR: 0, riskPerTradeEUR: 50 },
  { profitMinEUR: 2500, riskPerTradeEUR: 75 },
  { profitMinEUR: 5000, riskPerTradeEUR: 100 },
  { profitMinEUR: 7500, riskPerTradeEUR: 125 },
  { profitMinEUR: 10000, riskPerTradeEUR: 150 },
  { profitMinEUR: 12500, riskPerTradeEUR: 175 },
  { profitMinEUR: 15000, riskPerTradeEUR: 200 },
];

export const DEFAULT_RISK_PROFILE: RiskProfile = {
  maxLossThresholdEUR: 3000,
  baseRiskPerTradeEUR: 50,
  riskSteps: DEFAULT_RISK_STEPS,
  riskRewardRatio: 2,
  winProbabilityPct: 50,
  targetGoalEUR: 10000,
  planYear: currentYear,
};
